"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnOutsideClick = void 0;
var useOnOutsideClick_1 = require("./useOnOutsideClick");
Object.defineProperty(exports, "useOnOutsideClick", { enumerable: true, get: function () { return useOnOutsideClick_1.useOnOutsideClick; } });
//# sourceMappingURL=index.js.map